// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"dce81f58","1241":"1e69e967"}[chunkId] + ".chunk.css";
};